import { createContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const getJwtToken = () => {
        const localStorageToken = localStorage.getItem("jwtToken");
        if (localStorageToken) {
            return localStorageToken;
        }
    };

    const [jwtToken, setJwtToken] = useState(getJwtToken());
    const [userData, setUserData] = useState(null);

    const decodeJwt = (token) => {
        if (!token) return null;
        try {
            return JSON.parse(atob(token.split(".")[1]));
        } catch (err) {
            console.error("Invalid JWT Token:", err);
            return null;
        }
    };

    const refreshAccessToken = async () => {
        try {
            const response = await axios.post(`${API_URL}/api/refresh`, {}, {
                withCredentials: true
            });

            if (response.data.accessToken) {
                login(response.data.accessToken); 
            }
        } catch (error) {
            console.error("❌ Failed to refresh token:", error);
            logout();
        }
    };

    const login = (token) => {
        localStorage.setItem("jwtToken", token);
        setJwtToken(token);
        setUserData(decodeJwt(token));
    };

    const logout = () => {
        localStorage.removeItem("jwtToken");
        setJwtToken(null);
        setUserData(null);
    };

    useEffect(() => {
        const checkTokenBeforeExpiry = () => {
            const token = getJwtToken();
            if (token) {
                const decoded = decodeJwt(token);
                if (!decoded) return;

                const expirationTime = decoded.exp * 1000;
                const timeRemaining = expirationTime - Date.now();

                if (timeRemaining < 1 * 60 * 1000) {
                    refreshAccessToken();
                }
            }
        };

        checkTokenBeforeExpiry();
        const interval = setInterval(checkTokenBeforeExpiry, 60 * 1000);
        return () => clearInterval(interval);
    }, [jwtToken]);

    useEffect(() => {
        const checkToken = () => {
            const token = getJwtToken();
            if (!token) {
                if (location.pathname !== "/") {
                    navigate("/");
                }
                return;
            }

            const decoded = decodeJwt(token);
            if (!decoded) return;

            setJwtToken(token);
            setUserData(decoded);
        };

        checkToken();
        const interval = setInterval(checkToken, 60000);
        return () => clearInterval(interval);
    }, [navigate, location.pathname]);

    return (
        <AuthContext.Provider value={{ jwtToken, userData, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};